const KIT_QUANTITY_ZERO_TOLERANCE = 1e-9;

/**
 * Display kit-equivalent quantities with up to two decimal places, truncated (not rounded).
 * Examples: 1 → "1", 2/3 → "0.66", 1/3 → "0.33", 0 → "0".
 */
export function formatKitQuantity(value: number): string {
  if (Math.abs(value) < KIT_QUANTITY_ZERO_TOLERANCE) {
    return "0";
  }
  const nearestInt = Math.round(value);
  if (Math.abs(value - nearestInt) < KIT_QUANTITY_ZERO_TOLERANCE) {
    return String(nearestInt);
  }
  const truncated = Math.floor(value * 100) / 100;
  return truncated.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
